import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const RefinanceRequest = props => {
  const { label, value, highlited } = props;
  const classes = useStyles();

  return (
    <Box className={clsx(classes.row, { [classes.highlited]: highlited })}>
      <Box className={classes.labelBox}>
        <Typography variant="h2">{label}</Typography>
      </Box>
      <Box className={classes.valueBox}>
        <Typography variant="body1">{value}</Typography>
      </Box>
    </Box>
  );
};

RefinanceRequest.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  highlited: PropTypes.bool.isRequired,
};

export default RefinanceRequest;



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/components/SurveySummary/components/InfoRow/InfoRow.js